import axios from 'axios';
import { setSession } from 'src/pages/Auth/helpers/tokens';
import EventEmitter from './emitter';

// import { stores } from "../mobx-store";

interface ErrorResponse {
  timestamp: string;
  path: string;
  httpStatus: number;
  message: string | string[];
  // stack: string;
}

export const emitter = new EventEmitter();

const apiVersion = `api`;
// Setup Server URL

const serverURL = `https://app.hatched.es`;
// Construct Base URL
export const baseURL = `${serverURL}/${apiVersion}`;

const instance = axios.create({
  baseURL,
  // timeout: 100000
});

// Add a request interceptor
instance.interceptors.request.use(
  (config) => {
    // adding Authorization to all requests
    config.headers = {
      ...config.headers
    };


    return config;
  },
  (error) => {
    // Do something with request error
    return Promise.reject(error.response.data);
  }
);

instance.interceptors.response.use(
  (response) => {
    // Do something with response data
    return response;
  },
  async (error) => {
    const userSession = JSON.parse(localStorage.getItem('user'));
    // if (error && error.response.status === 401 && userSession) {
    //   console.log('Token-Expired-Refresh-Called');
    //   try {
    //     const response = await axios.request({
    //       baseURL,
    //       url: '/auth/refresh',
    //       method: 'post',
    //       headers: {
    //         Authorization: `Bearer ${localStorage.getItem('refreshToken')}`
    //       },
    //       data: {
    //         userId: Number(
    //           JSON.parse(window.localStorage.getItem('user')).userId
    //         ),
    //         refreshToken: `${localStorage.getItem('refreshToken')}`
    //       }
    //     });
    //     console.log('Token-Expired-Refresh-Response', response.data);
    //     const token: any = response;
    //     setSession(token.accessToken, token.refreshToken, userSession);
    //     return await axios.request({
    //       ...error.config,
    //       headers: {
    //         ...error.config.headers,
    //         Authorization: `Bearer ${token.accessToken}`
    //       }
    //     });
    //   } catch (errorAuthorize) {
    //     console.log('Token-Expired-Refresh-Failed', errorAuthorize.response);
    //     if (errorAuthorize.response.status === 401) {
    //       setSession(null, null, null);
    //       (window as Window).location = '/';
    //     }

    //     return Promise.reject(errorAuthorize);
    //   }
    // } else {
    //   emitter.emit('Error', error.response.data);
    // }
    // Do something with response error
    return Promise.reject(error.response.data);
  }
);

export default instance;
